"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CopySVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var innerSvg = '<path d="M6.975,27.941l3,.013V30H7.034a2.062,2.062,0,0,1-2.059-2.059V25H6.987Z"/><polygon points="15.975 27.979 15.975 30 11.975 30 11.975 27.962 15.975 27.979"/><path d="M20.916,28l.059-2h2v1.941A2.062,2.062,0,0,1,20.916,30H17.975V27.988Z"/><path d="M4.975,12.059A2.062,2.062,0,0,1,7.034,10H8.975v2H7.034l-.013,3H4.975Z"/><polygon points="7.013 17 6.996 23 4.975 23 4.975 17 7.013 17"/><path d="M13.084,2H26.866a2.109,2.109,0,0,1,2.109,2.109V21.892A2.108,2.108,0,0,1,26.867,24H13.084a2.108,2.108,0,0,1-2.108-2.108V4.109A2.109,2.109,0,0,1,13.084,2Z"/>';
var CopySVG = function CopySVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
exports.CopySVG = CopySVG;
CopySVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(CopySVG);
exports.default = _default;